import styled from 'styled-components';

import { colorStack } from '../../../../styleHelpers/colors';

export const NoNotificationInfo =  styled.h4`
    padding: 1rem;
    text-align: center;
    border-bottom: 1px solid ${colorStack.ligthGrey};
`;